<script setup lang="ts">
import { ref, watch } from 'vue'
import DialogSelect from '@/components/DialogSelect.vue'
import { useHoldReasonModal } from '@/composables/useHoldReasonModal'
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '@/foundation/select'

const { isHoldReasonModalOpen, holdReasonData, closeHoldReasonModal } = useHoldReasonModal()

const selectedReason = ref<string>('')

const reasonsToHold = ref([
  { name: 'Customer Contact - Failed', value: 'Customer Contact - Failed' },
  { name: 'Customer Contact - Successful / Customer Delayed', value: 'Customer Contact - Successful / Customer Delayed' },
  { name: '3rd Party Delay', value: '3rd Party Delay' },
  { name: 'Scheduled', value: 'Scheduled' },
  { name: 'Waiting on Client', value: 'Waiting on Client' },
])

watch(isHoldReasonModalOpen, (newValue) => {
  if (!newValue) {
    selectedReason.value = ''
  }
})

const onReasonSelect = () => {
  if (selectedReason.value && holdReasonData.value) {
    // Emit custom event with the reason
    const event = new CustomEvent('hold-reason-submitted', {
      detail: {
        ...holdReasonData.value,
        reason: selectedReason.value,
      },
    })

    window.dispatchEvent(event)
  }
  closeHoldReasonModal()
}

const onDialogClose = () => {
  closeHoldReasonModal()
}
</script>

<template>
  <DialogSelect
    v-model="isHoldReasonModalOpen"
    :selected-reason="selectedReason"
    @close-dialog="onReasonSelect"
    @dialog-closed="onDialogClose"
  >
    <template #title>Hold Reason Required</template>
    <template #subtitle> Please specify the reason for putting ticket #{{ holdReasonData?.ticketNumber }} on hold. </template>

    <Select v-model="selectedReason">
      <SelectTrigger>
        <SelectValue placeholder="Choose a reason for the hold">
          <template #default>
            {{ selectedReason || 'Choose a reason for the hold' }}
          </template>
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          <SelectItem
            v-for="reason in reasonsToHold"
            :key="reason.value"
            :value="reason.value"
            class="cursor-pointer hover:bg-accent"
          >
            {{ reason.name }}
          </SelectItem>
        </SelectGroup>
      </SelectContent>
    </Select>
  </DialogSelect>
</template>
